export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-die-four-6c338066db09b8045df63690ec63285f.svg";